import type { ItemDetectionStatus } from '@/utils/detectionStatus';
import { StatusBadge, type StatusBadgeVariant } from '@/components/shared/StatusBadge';
import { cn } from '@/lib/utils';

const STATUS_VARIANT: Record<ItemDetectionStatus, StatusBadgeVariant> = {
  detected: 'success',
  not_seen_recently: 'warning',
  missing: 'danger',
};

export interface ProductStatusBadgeProps {
  status: ItemDetectionStatus;
  label: string;
  className?: string;
}

export function ProductStatusBadge({
  status,
  label,
  className,
}: ProductStatusBadgeProps): JSX.Element {
  const variant = STATUS_VARIANT[status];
  return (
    <StatusBadge variant={variant} className={cn('whitespace-nowrap', className)}>
      {label}
    </StatusBadge>
  );
}
